// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.settlement-btn {
  background-color: #343a40; /* Bootstrap dark, slightly softened */
  color: #fff;
  font-size: 0.875rem;
  padding: 0.4rem 0.75rem;
  border-radius: 0.375rem;
  box-shadow: none;
  transition: background-color 0.2s ease;
}

.settlement-btn:hover {
  background-color: #23272b; /* Slightly darker on hover */
  color: #fff;
}

.settlement-btn:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.4); /* subtle focus */
}

.clearFilter {
  background-color: #f0f2f5;
  border: 1px solid #dadee2;
  color: #495057;
  font-size: 0.875rem; /* Slightly increase the font size for better readability */
  padding: 6px 12px;
  border-radius: 8px; /* Slightly rounded for a smoother look */
  font-weight: 500;
  text-align: center;
  transition: background-color 0.3s ease, box-shadow 0.3s ease, transform 0.2s ease; /* Added transition for scaling effect */
  cursor: pointer; /* Indicating it's clickable */
}

.clearFilter:hover {
  background-color: #e2e6ea;
  color: #212529;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12); /* Soft shadow for better hover effect */
  transform: scale(1.05); /* Slight scaling effect to make it feel interactive */
}

.clearFilter:active {
  background-color: #dae0e5; /* Darker background on active click */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); /* Slightly deeper shadow when clicked */
  transform: scale(0.98); /* Slight shrink when button is pressed */
}




/* Truncated text styling */
.truncate-cell {
  display: block;
  max-width: 100px; /* Adjust as needed */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/containers/Orders/Orders.css"],"names":[],"mappings":";;AAEA;EACE,yBAAyB,EAAE,sCAAsC;EACjE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,6BAA6B;EACxD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8CAA8C,EAAE,iBAAiB;AACnE;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,mBAAmB,EAAE,2DAA2D;EAChF,iBAAiB;EACjB,kBAAkB,EAAE,yCAAyC;EAC7D,gBAAgB;EAChB,kBAAkB;EAClB,iFAAiF,EAAE,wCAAwC;EAC3H,eAAe,EAAE,8BAA8B;AACjD;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yCAAyC,EAAE,wCAAwC;EACnF,sBAAsB,EAAE,sDAAsD;AAChF;;AAEA;EACE,yBAAyB,EAAE,sCAAsC;EACjE,yCAAyC,EAAE,wCAAwC;EACnF,sBAAsB,EAAE,yCAAyC;AACnE;;;;;AAKA,2BAA2B;AAC3B;EACE,cAAc;EACd,gBAAgB,EAAE,qBAAqB;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":["\n\n.settlement-btn {\n  background-color: #343a40; /* Bootstrap dark, slightly softened */\n  color: #fff;\n  font-size: 0.875rem;\n  padding: 0.4rem 0.75rem;\n  border-radius: 0.375rem;\n  box-shadow: none;\n  transition: background-color 0.2s ease;\n}\n\n.settlement-btn:hover {\n  background-color: #23272b; /* Slightly darker on hover */\n  color: #fff;\n}\n\n.settlement-btn:focus {\n  outline: none;\n  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.4); /* subtle focus */\n}\n\n.clearFilter {\n  background-color: #f0f2f5;\n  border: 1px solid #dadee2;\n  color: #495057;\n  font-size: 0.875rem; /* Slightly increase the font size for better readability */\n  padding: 6px 12px;\n  border-radius: 8px; /* Slightly rounded for a smoother look */\n  font-weight: 500;\n  text-align: center;\n  transition: background-color 0.3s ease, box-shadow 0.3s ease, transform 0.2s ease; /* Added transition for scaling effect */\n  cursor: pointer; /* Indicating it's clickable */\n}\n\n.clearFilter:hover {\n  background-color: #e2e6ea;\n  color: #212529;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12); /* Soft shadow for better hover effect */\n  transform: scale(1.05); /* Slight scaling effect to make it feel interactive */\n}\n\n.clearFilter:active {\n  background-color: #dae0e5; /* Darker background on active click */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); /* Slightly deeper shadow when clicked */\n  transform: scale(0.98); /* Slight shrink when button is pressed */\n}\n\n\n\n\n/* Truncated text styling */\n.truncate-cell {\n  display: block;\n  max-width: 100px; /* Adjust as needed */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
